import { render, staticRenderFns } from "./DirectMailProduct.vue?vue&type=template&id=433a5860&scoped=true"
import script from "./DirectMailProduct.vue?vue&type=script&lang=js"
export * from "./DirectMailProduct.vue?vue&type=script&lang=js"
import style0 from "./DirectMailProduct.vue?vue&type=style&index=0&id=433a5860&prod&lang=sass&scoped=true"
import style1 from "./DirectMailProduct.vue?vue&type=style&index=1&id=433a5860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a5860",
  null
  
)

export default component.exports